export function resolveNavbarBgColor(showTransparent, isDark) {
    if (showTransparent) return 'rgba(15, 23, 42, 0.75)';
    return isDark ? 'rgba(17, 28, 46, 0.95)' : 'rgba(255, 255, 255, 0.95)';
}

export function resolveNavbarBoxShadow(showTransparent, isDark) {
    if (showTransparent) return 'none';
    return isDark ? '0 4px 20px rgba(0, 0, 0, 0.5)' : 2;
}

export function resolveLogoColor(showTransparent, isDark) {
    if (showTransparent) return 'white';
    return isDark ? 'primary.light' : 'primary.main';
}

export function resolveLogoHoverColor(showTransparent, isDark) {
    if (showTransparent) return 'white';
    return isDark ? '#ffffff' : 'primary.light';
}

export function resolveMenuButtonColor(showTransparent, isDark) {
    if (showTransparent) return 'white';
    return isDark ? 'text.primary' : 'primary.main';
}
